// extracted by mini-css-extract-plugin
export default {"navbarItem":"NavbarItem_navbarItem__Xd4cw","active":"NavbarItem_active__n4t4s"};